mutation (
  $email: AWSEmail!
  $locale: Locale!
) {
  resendConfirmationCode(
    email: $email
    locale: $locale
  )
}
